module.exports = __webpack_public_path__ + "img/logo.a20eb263.svg";